/**
 * Product Detail Page
 */

export default function HWY_Product() {
	const selectors = {
		techspecs: "tech-specs",
        giftcard: ".gift-card-info div[v65remotejs='addToCartForm']"
	};

	function triggerTechSpecs() {
        const observer = new IntersectionObserver(intersectionCallback);
        const triggerElement = document.getElementById(selectors.techspecs);

        if (triggerElement)
            observer.observe(triggerElement);

    }

    function intersectionCallback( entries, observer ) {
        entries.forEach( function( entry ) {
            if ( entry.isIntersecting ) {
				jQuery(".tech-spec").addClass("animate");
                observer.disconnect()
            }
        });
    }

    function triggerGiftCardATC() {
        const targetNodes = document.querySelectorAll(selectors.giftcard);

        if (!targetNodes.length) {
            return;
        }

        targetNodes.forEach((target) => {
            new MutationObserver((mutations, observer) => {
                if (document.querySelector(".v65-widgetAddToCart")) {
                    observer.disconnect();

                    jQuery(".v65-widgetProduct-addToCart-price").each(function(index) {
                        const price = jQuery(this).text();
                        const html = `<option value="${index}">${price}</option>`;
                        jQuery(".gift-card-options").append(html);
                    })

                }
            }).observe(target, { childList: true, subtree: true });
        });
    }

	this.init = () => {
		triggerTechSpecs();
        triggerGiftCardATC();
	};
}
